import {trackShare} from './core';

export function fixSocialNetworkName(name) {
  let fixedName = name.charAt(0).toUpperCase() + name.slice(1);

  if (fixedName === 'Whatsapp') {
    return 'WhatsApp';
  }

  if (fixedName === 'Linkedin') {
    return 'LinkedIn';
  }

  return fixedName;
}

/**
 * Setup social network button with a 'Share' event to be tracked on click.
 *
 * @param element the button element with social network data.
 */
export const setup = function(element) {
  let socialNetwork = element.dataset.socialNetwork;

  if (socialNetwork) {
    socialNetwork = fixSocialNetworkName(socialNetwork);
    element.addEventListener('click', () => {
      trackShare(socialNetwork, element.dataset.url, element.dataset.title);
    });
  }
};